import React from "react";
import styles from "../styles";
import Utterance from "../Utterance";
import { ListItem, List, Typography, Checkbox, IconButton, Button, Box, Tooltip, withStyles } from "@material-ui/core";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";

class Cluster extends React.Component {

  shouldComponentUpdate(nextProps) {
    if (this.props.utterances !== nextProps.utterances ||
       this.props.selected !== nextProps.selected ||
       this.props.cluster === nextProps.activeCluster
       ) {
         console.log(nextProps.utterances);
      return true;
    }
    return false;
  }

  handleButtonClick = (id, e) => {
    this.props.mapToQuestionDialog(id, e);
  };

 
  render() {
    const {
      cluster,
      utterances,
      classes,
      selected,
      handleRadioChange,
      handleUtteranceSwitch,
      textSelectHandler,
      groupByIntent,
      connector 
    } = this.props;
    const specialType = cluster==="Utterance Placeholder"?true:false;
    const listClass = specialType ? classes.utteranceListSpecial : classes.utteranceList;
    const enableButton = Object.values(selected).indexOf("1") === -1 ? true : false;

    return (
      <React.Fragment>
        <ListItem className= {`${classes.clusterGroup} ${
                      specialType ? classes.activeClusterGroup : null
                    }`}>
            <Box className={classes.clusterTitle} onClick={this.handleClick}>
              
              <Typography variant="h5" component="h5">
                {cluster}{(!(typeof connector==='undefined' || connector===''))&&
                <span className={classes.clusterConnector}>{"[" + connector + "]"}</span>}
              </Typography>
            </Box>
          <div>
            {groupByIntent && (
              <Tooltip placement="top" title="Set intent">
                <span>
                  <IconButton onClick={() => this.props.openModal(cluster, "int")} disabled={enableButton}>
                    <PlaylistAddCheckIcon />
                  </IconButton>
                </span>
              </Tooltip>
            )}

            <Tooltip placement="top" title="Select best answer">
              <span>
                <IconButton onClick={this.handleButtonClick.bind(this, cluster)} disabled={enableButton}>
                  <SpellcheckIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </ListItem>
        {Object.keys(utterances).length > 0 && (
          <ListItem className={classes.listItemInner}>
            <div>
              <Checkbox
                onChange={this.props.selectAll.bind(this, cluster)}
                color="default"
                classes={{
                  root: classes.disabledCheckbox,
                  checked: classes.selectedCheckbox
                }}
              />
              <Typography variant="caption">Select All</Typography>
              </div>
            </ListItem>)}
              <List className={listClass}>
                {Object.entries(utterances).map(([key, utterance]) => {
                    return <Utterance 
                      key={key} 
                      clusterKey={cluster} 
                      utterance={utterance} 
                      id={key} 
                      selected={selected[key]}
                      handleRadioChange={handleRadioChange} 
                      handleUtteranceSwitch={handleUtteranceSwitch} 
                      textSelectHandler={textSelectHandler}
                      />
                    })}
                </List>
                {specialType&&
                <Button onClick={this.props.saveClusterFeedback} className={classes.mainClusterButton} variant="contained" size="large" color="primary">Train</Button>
                }
        </React.Fragment>
        ) 
    }
}

export default withStyles(styles)(Cluster);
